// HiBob scopes as readable text (i18n keys), grouped for the Settings page.
// Used by the install page and Settings -> Integration -> HiBob.
// access: "read", or "readWrite" for the one scope that writes to HiBob.
export const HIBOB_SCOPES = {
	"employee_data:read": {
		label: "hibob-scope-employee-data",
		purpose: "hibob-scope-employee-data-purpose",
		group: "people",
		access: "read",
	},
	"employee_data.history:read": {
		label: "hibob-scope-employee-history",
		purpose: "hibob-scope-employee-history-purpose",
		group: "people",
		access: "read",
	},
	"employee_data.sensitive:read": {
		label: "hibob-scope-employee-sensitive",
		purpose: "hibob-scope-employee-sensitive-purpose",
		group: "people",
		access: "read",
	},
	"employee_data.sensitive.history:read": {
		label: "hibob-scope-employee-sensitive-history",
		purpose: "hibob-scope-employee-sensitive-history-purpose",
		group: "people",
		access: "read",
	},
	"company.metadata:read": {
		label: "hibob-scope-company-lists",
		purpose: "hibob-scope-company-lists-purpose",
		group: "organization",
		access: "read",
	},
	"job_catalog:read": {
		label: "hibob-scope-job-catalog",
		purpose: "hibob-scope-job-catalog-purpose",
		group: "organization",
		access: "read",
	},
	"job_catalog.skills:read": {
		label: "hibob-scope-skills",
		purpose: "hibob-scope-skills-purpose",
		group: "organization",
		access: "read",
	},
	"timeoff:read": {
		label: "hibob-scope-timeoff-read",
		purpose: "hibob-scope-timeoff-read-purpose",
		group: "timeOff",
		access: "read",
	},
	"timeoff:write": {
		label: "hibob-scope-timeoff-write",
		purpose: "hibob-scope-timeoff-write-purpose",
		group: "timeOff",
		access: "readWrite",
	},
	"timeoff.sensitive:read": {
		label: "hibob-scope-timeoff-private",
		purpose: "hibob-scope-timeoff-private-purpose",
		group: "timeOff",
		access: "read",
	},
};

export const SCOPE_GROUPS = [
	{ group: "people", key: "hibob-group-people" },
	{ group: "organization", key: "hibob-group-organization" },
	{ group: "timeOff", key: "hibob-group-timeoff" },
	{ group: "other", key: "hibob-group-other" },
];

// "employee_data.sensitive:read" -> "Employee Data Sensitive Read". Never the raw id.
export const titleCaseScope = (scope) =>
	String(scope)
		.split(/[^A-Za-z0-9]+/)
		.filter(Boolean)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(" ");

const known = (scope) =>
	Object.prototype.hasOwnProperty.call(HIBOB_SCOPES, scope) ? HIBOB_SCOPES[scope] : null;

export const getScopeText = (scope, t) => {
	const entry = known(scope);
	return entry
		? { label: t(entry.label), purpose: t(entry.purpose) }
		: { label: titleCaseScope(scope), purpose: null };
};

// Granted scopes as groups in SCOPE_GROUPS order, empty groups left out.
export const groupScopes = (scopes, t) => {
	const items = (Array.isArray(scopes) ? scopes : [])
		.filter((scope) => typeof scope === "string" && scope)
		.map((scope) => {
			const entry = known(scope);
			return {
				scope,
				...getScopeText(scope, t),
				group: entry ? entry.group : "other",
				access: entry ? entry.access : scope.endsWith(":write") ? "readWrite" : "read",
			};
		});
	return SCOPE_GROUPS.map(({ group, key }) => ({
		group,
		title: t(key),
		items: items.filter((item) => item.group === group),
	})).filter(({ items: groupItems }) => groupItems.length > 0);
};
